import React from 'react'
import Stepper from "react-stepper-horizontal";
import AddSite from './AddSite';
import WebpusherIntegrate from './WebpusherIntegrate';
import VerifyInstallation from './VerifyInstallation';

export default function Index() {
    const [activeStep, setActiveStep] = React.useState(0);

    function getSectionComponent() {
        switch (activeStep) {
            case 0: return <AddSite setActiveStep={setActiveStep} />;
            case 1: return <WebpusherIntegrate setActiveStep={setActiveStep} />;
            case 2: return <VerifyInstallation />;
            default: return null;
        }
    }

    const steps = [
        { title: 'Add Your Site' },
        { title: 'Webpusher Integration' },
        { title: 'Verify Installation' },
    ];

    return (
        <>
            <div className="card mb-3">
                <div className="card-body">
                    <Stepper
                        steps={steps}
                        activeStep={activeStep} />
                    <div style={{ padding: '20px' }}>
                        {getSectionComponent()}
                    </div>
                </div>
            </div>
        </>
    )
}
